import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import TrackerCard from './trackerCard';

const FleetTracker = ({ hardwareList, tracker }) => {
  const {
    iotOrderDetailsSection: { labelFleetTracker }
  } = useLocalizedStringsContext();

  const {
    fleetTrackerRateplanTotal,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: labelFleetTracker,
    hardwareList,
    rateplanTotal: fleetTrackerRateplanTotal,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

FleetTracker.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    fleetTrackerRateplanTotal: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default FleetTracker;
